@switch (type()) {
  @case ('Vet-Call') {
    <ng-container *ngTemplateOutlet="NonActiveVetCard"></ng-container>
  }
  @case ('Vet-Call-Highlighted') {
    <ng-container *ngTemplateOutlet="NonActiveVetCard"></ng-container>
  }
  @case ('Vet-Chat') {
    <ng-container *ngTemplateOutlet="NonActiveVetCard"></ng-container>
  }
  @case ('Vet-Chat-Active') {
    <ng-container *ngTemplateOutlet="ActiveVetChatCard"></ng-container>
  }
}

<ng-template #NonActiveVetCard>
  <div
    class="min-h-[168px] w-full h-full px-4 py-6 rounded-[10px] shadow-[0px_6px_10px_0px_rgba(0,0,0,0.08)] shadow-[0px_-1px_10px_0px_rgba(0,0,0,0.08)] flex-col justify-start items-start gap-2 inline-flex hover:scale-105 transition-all duration-150 cursor-pointer"
    [ngStyle]="{ 'background-color': type() === 'Vet-Call-Highlighted' ? '#cadff3' : '#ffffff' }"
    [class.disabled]="status() === 'unavailable'"
  >
    <!-- Card Heading -->
    @if (iconSrc() && iconType()) {
      <div class="h-14 w-full justify-between items-start inline-flex gap-x-2">
        <div class="w-14 h-14 relative overflow-hidden">
          <!-- Icon -->
          @switch (iconType()) {
            @case ('svg') {
              <svg-icon src="{{ iconSrc() }}" />
            }
            @case ('image') {
              <img class="w-full h-full object-cover" src="{{ iconSrc() }}" alt="icon" />
            }
          }
        </div>
        <div class="justify-start items-center gap-1 flex">
          @if (status()) {
            <div class="w-2 h-2 rounded-full" [ngStyle]="{ background: statusColor() }"></div>
          }
          <div class="text-[#222222] text-xs font-medium font-['Poppins'] leading-[18px] tracking-tight">
            {{ statusText() }}
          </div>
        </div>
      </div>
    }
    <!-- Card Content -->
    <div class="min-h-14 justify-between items-start inline-flex w-full">
      <div class="grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
        <div class="self-stretch text-[#222222] text-lg font-medium font-['Poppins'] leading-[27px] tracking-tight">
          {{ title() }}
        </div>
        <div class="self-stretch text-[#222222] text-sm font-normal font-['Poppins'] leading-[21px] tracking-tight">
          {{ subtitle() }}
        </div>
      </div>
      @if (status() !== 'unavailable') {
        <div class="flex-col justify-center items-center inline-flex">
          <lucide-angular class="text-[#222222]" name="chevron-right" [size]="24" />
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #ActiveVetChatCard>
  <div
    class="min-h-[122px] w-full h-full px-4 py-6 rounded-[10px] shadow-[0px_6px_10px_0px_rgba(0,0,0,0.08)] shadow-[0px_-1px_10px_0px_rgba(0,0,0,0.08)] flex-col justify-start items-start gap-2 inline-flex hover:scale-105 transition-all duration-150 cursor-pointer bg-[#e9fae2] border border-[#2a7407]"
  >
    <!-- Card Heading -->
    <div class="h-14 justify-between items-center inline-flex w-full">
      <div class="justify-start items-center gap-4 flex">
        <div class="w-14 h-14 justify-center items-center flex relative">
          <!-- Icon -->
          @if (iconSrc() && iconType()) {
            @switch (iconType()) {
              @case ('svg') {
                <div
                  class="w-14 h-14 bg-primary border border-[#2a7407] rounded-full overflow-hidden flex items-center justify-center"
                >
                  <svg-icon class="scale-125" src="{{ iconSrc() }}" />
                </div>
              }
              @case ('image') {
                <img class="w-14 h-14 rounded-full border border-[#2a7407]" [src]="iconSrc()" alt="avatar" />
              }
            }
          }
          @if (unreadMessageCount() > 0) {
            <div class="unread-count">
              <span class="w-6 text-center text-white text-base font-normal">{{ unreadMessageCount() }}</span>
            </div>
          }
        </div>
        <div class="text-[#222222] text-lg font-medium font-['Poppins'] leading-[27px] tracking-tight">
          Chat in progress
        </div>
      </div>
      <div class="flex-col justify-center items-center inline-flex">
        <lucide-angular class="text-[#222222]" name="chevron-right" [size]="24" />
      </div>
    </div>
    <div class="h-[18px] justify-start items-center gap-1 inline-flex">
      @if (status()) {
        <div class="w-2 h-2 rounded-full" [ngStyle]="{ background: '#20e070' }"></div>
      }
      @if (lastVetReply()) {
        <div class="text-[#222222] text-xs font-medium font-['Poppins'] leading-[18px] tracking-tight">
          Last reply {{ $any(lastVetReply()) | humanizeTime: now() }}
        </div>
      } @else {
        <div class="text-[#222222] text-xs font-medium font-['Poppins'] leading-[18px] tracking-tight">
          No replies yet
        </div>
      }
    </div>
  </div>
</ng-template>
